export default {
    items: [
        {
            id: "cyber-otter",
            artist_id: "daydreamos",
            id_photos_preview: ["products/cyber-otter-0.jpg"],
            id_photos: ["products/cyber-otter-1.jpg", "products/cyber-otter-2.jpg", "products/cyber-otter-3.jpg", "products/cyber-otter-4.jpg"],
            
            name: "CYBER OTTER",
            briefDescription: {
                it: "Controller in mano, un robot e qualcuno che tenta di sfuggirgli. Come andrà a finire? Per i pesci, non benissimo",
                en: "Controller at hand, a robot and someone trying to escape it. How it will end? For the fishes, not very well."
            },
            description: {
                it: "Controller in mano, un robot e qualcuno che tenta di sfuggirgli. Come andrà a finire? Per i pesci, non benissimo\n\nOversize Fit\n100% Cotone\nLavaggio a 30° C\n\nConsulta la tabella taglie per un fit che fa la differenza.",
                en: "Controller at hand, a robot and someone trying to escape it. How it will end? For the fishes, not very well.\n\nOversize Fit\n100% Cotton\n30° C Wash\n\nCheck the size chart for a fit that makes a difference."
            },
            price: "€ 35",
            availability: [
                { size: "XS", stock: true },
                { size: "S", stock: true },
                { size: "M", stock: true },
                { size: "L", stock: true },
                { size: "XL", stock: true },
                { size: "XXL", stock: true }
            ],
            sizeTable: {
                "XS": { height: 67, length: 50 },
                "S": { height: 70, length: 54 },
                "M": { height: 73, length: 58 },
                "L": { height: 76, length: 62 },
                "XL": { height: 79, length: 66 },
                "XXL": { height: 82, length: 70 }
            }
        },
        {
            id: "dragon-taste",
            artist_id: "daydreamos",
            id_photos_preview: ["products/dragon-taste-0.jpg",],
            id_photos: ["products/dragon-taste-1.jpg", "products/dragon-taste-2.jpg", "products/dragon-taste-3.jpg", "products/dragon-taste-4.jpg"],

            name: "DRAGON TASTE",
            briefDescription: {
                it: "Sempre pronti a guardarti le spalle. Draghi in rosso come  omaggio all’irezumi Giapponese, simbolo di protezione e saggezza. Draghi. Noodles. Got it?",
                en: "Always ready to get you covered. Red painted dragons as a tribute to Japanese irezumi, symbol of protection and wisdom. Dragons. Noodles. Got it?"
            },
            description: {
                it: "Sempre pronti a guardarti le spalle. Draghi in rosso come  omaggio all’irezumi Giapponese, simbolo di protezione e saggezza. Draghi. Noodles. Got it?\n\nOversize Fit\n100% Cotone\nLavaggio a 30° C\n\nConsulta la tabella taglie per un fit che fa la differenza.",
                en: "Always ready to get you covered. Red painted dragons as a tribute to Japanese irezumi, symbol of protection and wisdom. Dragons. Noodles. Got it?\n\nOversize Fit\n100% Cotton\n30° C Wash\n\nCheck the size chart for a fit that makes a difference."
            },
            price: "€ 35",
            availability: [
                { size: "S", stock: true },
                { size: "M", stock: true },
                { size: "L", stock: true },
                { size: "XL", stock: true },
                { size: "XXL", stock: true }
            ],
            sizeTable: {
                "S": { height: 73, length: 54 },
                "M": { height: 75, length: 57 },
                "L": { height: 77, length: 60 },
                "XL": { height: 79, length: 63 },
                "XXL": { height: 81, length: 66 }
            }
        },
        {
            id: "classy-cat",
            artist_id: "daydreamos",
            id_photos_preview: ["products/classy-cat-0.jpg"],
            id_photos: ["products/classy-cat-1.jpg", "products/classy-cat-2.jpg", "products/classy-cat-3.jpg", "products/classy-cat-4.jpg"],

            name: "CLASSY CAT",
            briefDescription: {
                it: "Crazy cat dude? Don’t care. Apprezzerai in ogni caso la melodia delle quattro zampe sugli ottantotto tasti. Per cat people only, ma anche chi nega di esserlo.",
                en: "Crazy cat dude? Don’t care. In any case, you’ll love the four paws melody on the eighty-eight keys. For cat people only, but even for who denies it."
            },
            description: {
                it: "Crazy cat dude? Don’t care.\nApprezzerai in ogni caso la melodia delle quattro zampe sugli ottantotto tasti. Per cat people only, ma anche chi nega di esserlo.\n\nOversize Fit\n100% Cotone\nLavaggio a 30° C\n\nConsulta la tabella taglie per un fit che fa la differenza.",
                en: "Crazy cat dude? Don’t care.\nIn any case, you’ll love the four paws melody on the eighty-eight keys. For cat people only, but even for who denies it.\n\nOversize Fit\n100% Cotton\n30° C Wash\n\nCheck the size chart for a fit that makes a difference."
            },
            price: "€ 35",
            availability: [
                { size: "S", stock: true },
                { size: "M", stock: true },
                { size: "L", stock: true },
                { size: "XL", stock: true },
                { size: "XXL", stock: true }
            ],
            sizeTable: {
                "S": { height: 73, length: 54 },
                "M": { height: 75, length: 57 },
                "L": { height: 77, length: 60 },
                "XL": { height: 79, length: 63 },
                "XXL": { height: 81, length: 66 }
            }
        }
    ]
}